import { Injectable } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';
import * as fromOrganization from './organization.reducer';
import * as OrganizationSelectors from './organization.selectors';

@Injectable()
export class OrganizationFacade {
  loaded$ = this.store.pipe(
    select(OrganizationSelectors.getOrganizationLoaded)
  );
  currentOrganization$ = this.store.pipe(
    select(OrganizationSelectors.getCurrentOrganization)
  );
  organizationImage$ = this.store.pipe(
    select(OrganizationSelectors.getOrganizationImage)
  );
  uploadImage$ = this.store.pipe(
    select(OrganizationSelectors.uploadOrganizationImage)
  );
  constructor(
    private store: Store<fromOrganization.OrganizationPartialState>
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
